<template>
  <div class="main-content">
    <div class="head">
      <author-jin-nang-statistic
        v-if="jinNangDetail"
        :detail="jinNangDetail"
      ></author-jin-nang-statistic>
    </div>
    <div class="body">
      <div class="left">
        <jin-nang-tabs></jin-nang-tabs>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import JinNangTabs from '@/components/AuthorJinNang/JinNangTabs.vue'
import AuthorJinNangStatistic from '@/components/AuthorJinNangStatistic/AuthorJinNangStatistic.vue'
import { getAuthorJinNangList } from '@/api/AuthorJinNang'

export default {
  name: 'AuthorJinNangCancle',
  components: { AuthorJinNangStatistic, JinNangTabs },
  data() {
    return {
      jinNangDetail: null,
      viewState: '',
      dialogVisible: false,
      pageSize: 1000,
      pageIndex: 0,
      total: 0,
      orderby: 'desc'
    }
  },
  created() {
    this.getAuthorJinNangData()
  },
  computed: {
    currentJinNangId() {
      return this.$route.params.id
    }
  },
  methods: {
    async getAuthorJinNangData() {
      const data = await getAuthorJinNangList(
        {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          orderby: this.orderby
        },
        this.viewState
      )
      if (data && data.result.code === 0) {
        this.jinNangDetail = data.detail.list.find(
          a => a.jinNangId === Number(this.currentJinNangId)
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  margin: auto;
}

.head {
  margin-bottom: 20px;
}

.body {
  display: flex;
  flex-flow: row nowrap;
  min-width: 1200px;
}

.left {
  flex: none;
}

.right {
  background-color: #ffffff;
  margin-left: 20px;
  flex: auto;
  border-radius: 5px;
}
</style>
